module.exports = __webpack_public_path__ + "img/3.06a7e85a.jpg";